export const DIGITAL_CHANNEL = 'Digital';
export const ANALOGUE_CHANNEL = 'Analogue';